import AbstractSubject from '@naturehouse/nh-essentials/lib/architecture/ObserverPattern';

export type AggregationItem = {
    name: string;
    count: number;
};

export type AggregationCategory = {
    name: string;
    items: AggregationItem[];
};

export type InitialState = {
    aggregations: AggregationCategory[];
};

export default class AggregationItems extends AbstractSubject {
    static #instance: AggregationItems | null = null;

    #aggregations: AggregationCategory[] = [];

    get aggregations(): AggregationCategory[] {
        return this.#aggregations;
    }

    set aggregations(items: AggregationCategory[]) {
        this.#aggregations = items;
        this.notify();
    }

    public static getInstance(initialState: InitialState = { aggregations: [] }): AggregationItems {
        if (AggregationItems.#instance === null) {
            AggregationItems.#instance = new AggregationItems();
            AggregationItems.#instance.#aggregations = initialState.aggregations;
        }

        return AggregationItems.#instance;
    }
}
